// GENERATED FILE - DO NOT MODIFY

export enum UserBadgeDto {
    Expert = "Expert",
    Leader = "Leader",
    Mentor = "Mentor",
}